import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./TrueCom.css";
import tcoSection from "../../assets/tco-section.png";
import tcoSection1 from "../../assets/tco-section1.png";
import tcoSection2 from "../../assets/tco-section2.png";
import tcoSection3 from "../../assets/tco-section3.png";
import tcoSection4Img from "../../assets/tco-section4.png";
import tcoSection5Icon1 from "../../assets/tco-section5-icon1.png";
import tcoSection5Icon2 from "../../assets/tco-section5-icon2.png";
import tcoSection5Icon3 from "../../assets/tco-section5-icon3.png";
import tcoSection5Icon4 from "../../assets/tco-section5-icon4.png";
import tcoSection6Img1 from "../../assets/tco-section6-img1.png";
import tcoSection6Img2 from "../../assets/tco-section6-img2.png";
import tcoAdv1 from "../../assets/tco-adv1.png";
import tcoAdv2 from "../../assets/tco-adv2.png";
import tcoAdv3 from "../../assets/tco-adv3.png";
import tcoAdv4 from "../../assets/tco-adv4.png";
import tcoSection9Img from "../../assets/next.png";
import ecoBg from "../../assets/eco-bg.png";
import comBenefits1 from "../../assets/combenefits-1.png";
import comBenefits2 from "../../assets/truecomoverall-2.png";
import comBenefits3 from "../../assets/combenefits-3.png";
import comBenefits4 from "../../assets/combenefits-4.png";
import comBenefits5 from "../../assets/combenefits-5.png";

const useReveal = () => {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.65) {
        el.classList.add("is-visible");
        window.removeEventListener("scroll", check);
      }
    };
    const timer = setTimeout(() => {
      window.addEventListener("scroll", check, { passive: true });
      check();
    }, 400);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("scroll", check);
    };
  }, []);
  return ref;
};

/* ================================================
   SECTION 1 — HERO
   ================================================ */
const TrueComHero = () => {
  const navigate = useNavigate();
  return (
  <section className="tco-hero-section" style={{ "--eco-bg": `url(${ecoBg})` }}>
    <div className="tco-hero-container">
      <div className="tco-hero-left tco-hero-left-animate">
        <h1 className="tco-hero-title">
          Automated Billing.{"\n"}Seamless Compliance.{"\n"}Verified Climate
          Impact.
        </h1>
        <p className="tco-hero-desc">
          TrueCom™ is the commercial brain of True Renewables' digital ecosystem
          — an intelligent, automated platform that handles all financial,
          regulatory, billing, settlement and climate-related operations with
          absolute accuracy.
        </p>
        <button className="tco-hero-btn" onClick={() => navigate("/contact")}>Book A Free Call</button>
      </div>
      <div className="tco-hero-right">
        <picture>
          {/* Mobile image */}
          <source media="(max-width: 767px)" srcSet={tcoSection1} />

          {/* Desktop + Tablet image */}
          <img
            src={tcoSection}
            alt="TrueTrack Hero"
            className="tt-hero-phone"
          />
        </picture>
      </div>
    </div>
  </section>
);
}
/* ================================================
   SECTION 2 — WHAT IS TRUECOM
   ================================================ */
const tcoCheckItems = [
  "Energy billing",
  "Open access charges reconciliation",
  "Group captive financial settlements",
  "DISCOM documentation",
  "Carbon credit issuance",
  "REC & I-REC lifecycle management",
  "ESG reporting",
  "EMI / loan payment tracking",
  "Investor reporting",
  "Digital documentation vault",
];

const TrueComAbout = () => {
  const rightRef = useReveal();
  return (
    <section className="tco-about-section">
      <div className="tco-about-left">
        <img
          src={tcoSection2}
          alt="TrueCom Dashboard"
          className="tco-about-img"
          loading="lazy"
        />
      </div>
      <div className="tco-about-right reveal-block" ref={rightRef}>
        <p className="tco-about-heading">
          TrueCom™ is a fully integrated commercial intelligence platform that
          automates everything after your plant starts generating:
        </p>
        <ul className="tco-about-list">
          {tcoCheckItems.map((item) => (
            <li key={item} className="tco-about-list-item">
              <svg
                className="tco-check-icon"
                width="16"
                height="13"
                viewBox="0 0 16 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 6L6 11L15 1"
                  stroke="#C04820"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {item}
            </li>
          ))}
        </ul>
        <p className="tco-about-footer">
          It ensures your solar plant remains financially transparent, compliant
          and profitable — without manual work.
        </p>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 3 — WHY TRUECOM EXISTS
   ================================================ */
const tcoLeftCards = [
  {
    num: "01",
    text: "OA charges are miscalculated and SLDC billing errors go unnoticed.",
  },
  { num: "02", text: "Group captive equity settlements are confusing." },
  { num: "03", text: "DISCOM submissions require constant tracking." },
];
const tcoRightCards = [
  { num: "04", text: "Carbon credits are never formally issued." },
  { num: "05", text: "REC/I-REC compliance is misunderstood" },
  { num: "06", text: "EMI schedule tracking is inconsistent" },
];

const TrueComWhyExists = () => {
  const headerRef = useReveal();
  return (
    <section className="tco-why">
      <div className="tco-why-header reveal-block" ref={headerRef}>
        <p className="tco-why-tag">
          <span className="tco-why-dot" />
          WHY CHOOSE US
        </p>
        <h2 className="tco-why-title">Why TrueCom™ Exists</h2>
        <p className="tco-why-subtitle">
          Traditional solar commercial management is broken:
        </p>
      </div>
      <div className="tco-why-body">
        <div className="tco-why-col">
          {tcoLeftCards.map((c) => (
            <div className="tco-why-card" key={c.num}>
              <p className="tco-why-num">{c.num}</p>
              <p className="tco-why-text">{c.text}</p>
            </div>
          ))}
        </div>
        <div className="tco-why-img-wrap">
          <img
            src={tcoSection3}
            alt="Why TrueCom Exists"
            className="tco-why-img"
            loading="lazy"
          />
        </div>
        <div className="tco-why-col">
          {tcoRightCards.map((c) => (
            <div className="tco-why-card" key={c.num}>
              <p className="tco-why-num">{c.num}</p>
              <p className="tco-why-text">{c.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 4 — CORE CAPABILITIES
   ================================================ */
const tcoCapItems = [
  {
    title: "Automated Billing for Solar Consumption",
    desc: "TrueCom™ automatically calculates and generates all billing formats:",
    checks: [
      "Captive consumption",
      "Group captive share allocation",
      "Open access energy charges",
      "Rooftop excess/deficit settlements",
      "Consumer-wise billing",
      "Monthly energy credits",
    ],
    img: comBenefits1,
  },
  {
    title: "Open Access Charges & Settlement Reconciliation",
    desc: "TrueCom™ reconciles:",
    checks: [
      "Wheeling & banking charges",
      "Transmission costs",
      "Cross-subsidy surcharges & SLDC fees",
      "Loss adjustments & Grid support charges",
    ],
    img: comBenefits2,
  },
  {
    title: "Group Captive Financial Management",
    desc: "TrueCom™ handles all mandatory compliance:",
    checks: [
      "Shareholder consumption mapping",
      "Equity ratio validation",
      "Annual compliance documentation",
      "Individual investor billing & settlements",
      "Profit-share or cost-share tracking",
      "Automated compliance reminders",
    ],
    img: comBenefits3,
  },
  {
    title: "Loan, EMI & Payment Tracking",
    desc: "For financed plants, TrueCom™ manages:",
    checks: [
      "EMI schedule & payment reminders",
      "Outstanding balances",
      "Digital receipts & bank-ready reports",
    ],
    img: comBenefits4,
  },
  {
    title: "ESG & Sustainability Reporting",
    desc: "TrueCom™ automatically generates:",
    checks: [
      "Scope 2 emissions reduction",
      "Green energy contribution",
      "Carbon offset reports",
      "Sustainability dashboards",
      "Monthly & annual climate statement",
    ],
    img: comBenefits5,
  },
];

const CheckIcon = () => (
  <svg
    width="16" height="12" viewBox="0 0 16 12"
    fill="none" xmlns="http://www.w3.org/2000/svg"
    className="tco-cap-check-icon"
  >
    <path
      d="M1 5.5L5.5 10L15 1"
      stroke="#C04820" strokeWidth="2"
      strokeLinecap="round" strokeLinejoin="round"
    />
  </svg>
);

const TrueComCapabilities = () => {
  const headerRef = useReveal();
  const sectionRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fillPct, setFillPct] = useState(0);

  const activeIndexRef = useRef(0);
  const rafRef = useRef(null);
  const startTimeRef = useRef(null);
  const DURATION = 2500;

  const startTimer = (newIndex) => {
    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    activeIndexRef.current = newIndex;
    setActiveIndex(newIndex);
    setFillPct(0);
    startTimeRef.current = null;

    const animate = (timestamp) => {
      if (!startTimeRef.current) startTimeRef.current = timestamp;
      const elapsed = timestamp - startTimeRef.current;
      const pct = Math.min((elapsed / DURATION) * 100, 100);
      setFillPct(pct);
      if (pct < 100) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        const next = (activeIndexRef.current + 1) % tcoCapItems.length;
        startTimer(next);
      }
    };

    rafRef.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startTimer(0);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, []);

  const barStyle = {
    background: `linear-gradient(to bottom, #f05a28 0%, #f05a28 ${fillPct}%, #e4e4e4 ${fillPct}%, #e4e4e4 100%)`,
  };

  return (
    <section className="tco-cap" ref={sectionRef}>
      <div className="tco-cap-header reveal-block" ref={headerRef}>
        <p className="tco-cap-tag">
          <span className="tco-cap-dot" />
          OVERALL BENEFITS
        </p>
        <h2 className="tco-cap-title">Core Capabilities of TrueCom™</h2>
      </div>

      <div className="tco-cap-body">
        <div className="tco-cap-list">

          {/* First item */}
          <div>
            <div
              className={`tco-cap-item ${
                activeIndex === 0 ? "tco-cap-item--active" : ""
              }`}
              onClick={() => startTimer(0)}
            >
              {activeIndex === 0 && <span className="tco-cap-bar" style={barStyle} />}
              <div className="tco-cap-text">
                <p className="tco-cap-item-title">{tcoCapItems[0].title}</p>
                {activeIndex === 0 && (
                  <>
                    <p className="tco-cap-item-desc">{tcoCapItems[0].desc}</p>
                    <ul className="tco-cap-checklist">
                      {tcoCapItems[0].checks.map((check, j) => (
                        <li key={j} className="tco-cap-check-item">
                          <CheckIcon />
                          {check}
                        </li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            </div>
            {/* Mobile-only inline image — appears below the active item */}
            <div className="tco-cap-mobile-img-wrap">
              <div className="tco-cap-mobile-img-bg" />
              <img
                src={tcoCapItems[0].img}
                alt={tcoCapItems[0].title}
                className="tco-cap-mobile-img"
                loading="lazy"
              />
            </div>
            <hr className="tco-cap-divider" />
          </div>

          {/* Remaining items */}
          {tcoCapItems.slice(1).map((item, i) => {
            const idx = i + 1;
            return (
              <div key={idx}>
                <div
                  className={`tco-cap-item ${
                    activeIndex === idx ? "tco-cap-item--active" : ""
                  }`}
                  onClick={() => startTimer(idx)}
                >
                  {activeIndex === idx && <span className="tco-cap-bar" style={barStyle} />}
                  <div className="tco-cap-text">
                    <p className="tco-cap-item-title">{item.title}</p>
                    {activeIndex === idx && (
                      <>
                        <p className="tco-cap-item-desc">{item.desc}</p>
                        <ul className="tco-cap-checklist">
                          {item.checks.map((check, j) => (
                            <li key={j} className="tco-cap-check-item">
                              <CheckIcon />
                              {check}
                            </li>
                          ))}
                        </ul>
                      </>
                    )}
                  </div>
                </div>
                {/* Mobile-only inline image — appears below the active item */}
                <div className="tco-cap-mobile-img-wrap">
                  <div className="tco-cap-mobile-img-bg" />
                  <img
                    src={item.img}
                    alt={item.title}
                    className="tco-cap-mobile-img"
                    loading="lazy"
                  />
                </div>
                <hr className="tco-cap-divider" />
              </div>
            );
          })}
        </div>

        {/* Desktop-only: image on the right */}
        <div className="tco-cap-img-wrap tco-cap-img-wrap--desktop">
          <div className="tco-cap-img-bg" />
          <img
            src={tcoCapItems[activeIndex].img}
            alt="Core Capabilities"
            className="tco-cap-img"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
/* ================================================
   SECTION 5 — CARBON INTELLIGENCE ENGINE
   ================================================ */
const tcoEngineCards = [
  {
    icon: tcoSection5Icon1,
    title: "Automated REC / I-REC Tracking",
    bullets: [
      "Generation data captured from TrueCare™",
      "Certificate eligibility verified",
      "Credits issued & stored in your carbon wallet",
    ],
  },
  {
    icon: tcoSection5Icon2,
    title: "Carbon Credit Issuance (VER, Gold Standard, Verra)",
    bullets: [
      "Baseline methodology mapping",
      "Document generation",
      "Verification-ready datasets",
      "Annual issuance tracking",
    ],
  },
  {
    icon: tcoSection5Icon3,
    title: "Carbon Wallet",
    desc: "A digital space to store, trade, hold or retire credits.",
    bullets: [],
  },
  {
    icon: tcoSection5Icon4,
    title: "Climate Performance Dashboard",
    bullets: [
      <>
        Total CO<sub>2</sub> avoided
      </>,
      "Climate impact scores",
      "Emission reductions per month & year",
      "Investor-ready climate statements",
    ],
  },
];

const TrueComEngine = () => {
  const headerRef = useReveal();
  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () =>
    setActiveIndex((i) => (i === 0 ? tcoEngineCards.length - 1 : i - 1));
  const next = () =>
    setActiveIndex((i) => (i === tcoEngineCards.length - 1 ? 0 : i + 1));

  return (
    <section className="tco-engine">
      <div className="tco-engine-header reveal-block" ref={headerRef}>
        <p className="tco-engine-tag">
          <span className="tco-engine-dot" />
          SUBSIDY STRUCTURE
        </p>
        <h2 className="tco-engine-title">The Carbon Intelligence Engine</h2>
        <p className="tco-engine-subtitle">
          TrueCom™ integrates directly with True Renewables' Carbon Credits
          &amp; Climate Assets ecosystem, giving you:
        </p>
      </div>

      {/* Desktop grid */}
      <div className="tco-engine-cards tco-engine-cards--desktop">
        {tcoEngineCards.map((card, i) => (
          <div className="tco-engine-card" key={i}>
            <div className="tco-engine-icon-wrap">
              <img
                src={card.icon}
                alt={card.title}
                className="tco-engine-icon"
                loading="lazy"
              />
            </div>
            <p className="tco-engine-card-title">{card.title}</p>
            {card.desc && <p className="tco-engine-card-desc">{card.desc}</p>}
            {card.bullets && card.bullets.length > 0 && (
              <ul className="tco-engine-card-list">
                {card.bullets.map((b, j) => (
                  <li key={j} className="tco-engine-card-item">
                    {b}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* Mobile carousel */}
      <div className="tco-engine-carousel">
        <div className="tco-engine-card tco-engine-card--mobile">
          <div className="tco-engine-icon-wrap">
            <img
              src={tcoEngineCards[activeIndex].icon}
              alt={tcoEngineCards[activeIndex].title}
              className="tco-engine-icon"
              loading="lazy"
            />
          </div>
          <p className="tco-engine-card-title">
            {tcoEngineCards[activeIndex].title}
          </p>
          {tcoEngineCards[activeIndex].desc && (
            <p className="tco-engine-card-desc">
              {tcoEngineCards[activeIndex].desc}
            </p>
          )}
          {tcoEngineCards[activeIndex].bullets &&
            tcoEngineCards[activeIndex].bullets.length > 0 && (
              <ul className="tco-engine-card-list">
                {tcoEngineCards[activeIndex].bullets.map((b, j) => (
                  <li key={j} className="tco-engine-card-item">
                    {b}
                  </li>
                ))}
              </ul>
            )}
        </div>

        {/* Nav arrows */}
        <div className="tco-engine-nav">
          <button className="tco-engine-nav-btn" onClick={prev}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 18L9 12L15 6"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
          <button className="tco-engine-nav-btn" onClick={next}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M9 18L15 12L9 6"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </div>

      <p className="tco-engine-footer">
        This makes TrueCom™ the first platform in India to combine solar billing
        + compliance + carbon monetization in one system.
      </p>
    </section>
  );
};
/* ================================================
   SECTION 6 — DUAL-DASHBOARD ARCHITECTURE
   ================================================ */
const tcoDashTabs = [
  {
    id: "finance",
    label: "Finance & Compliance Dashboard",
    img: tcoSection6Img1,
    title: "Finance & Compliance Dashboard",
    subtitle: "For CFOs, finance teams, auditors, DISCOM coordinators.",
    checks: [
      "Detailed charge breakdown",
      "OA + SLDC reconciliation",
      "Multi-year billing reports",
      "Compliance trackers",
      "Carbon verification logs",
      "Billing exceptions",
      "Audit-ready documents",
    ],
  },
  {
    id: "owner",
    label: "Owner / Investor Dashboard",
    img: tcoSection6Img2,
    title: "Owner / Investor Dashboard",
    subtitle:
      "Clean, non-technical experience for plant owners and shareholders.",
    checks: [
      "Monthly savings",
      "Total energy consumed",
      "Outstanding payments/EMI",
      "Carbon credits earned",
      "Monthly billing summaries",
      "ROI progress",
      "Profit-share updates (group captive)",
    ],
  },
];

const TrueComDualDashboard = () => {
  const [activeTab, setActiveTab] = useState("finance");
  const sectionRef = useRef(null);
  const leftRef = useReveal();
  const active = tcoDashTabs.find((t) => t.id === activeTab);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;

    const onScroll = () => {
      
      const rect = section.getBoundingClientRect();
      const totalScroll = section.offsetHeight - window.innerHeight;
      const scrolled = -rect.top;
      const progress = scrolled / totalScroll;
      setActiveTab(progress >= 0.5 ? "owner" : "finance");
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="tco-dual-scroll-wrapper" ref={sectionRef}>
      <section className="tco-dual">
        {/* ── DESKTOP layout ── */}
        <div className="tco-dual-inner tco-dual-desktop">
          {/* ── LEFT ── */}
          <div className="tco-dual-left reveal-block" ref={leftRef}>
            <div className="tco-dual-left-header">
              <p className="tco-dual-tag">
                <span className="tco-dual-dot" />
                CLARITY AND CONTROL
              </p>
              <h2 className="tco-dual-title">Dual-Dashboard Architecture</h2>
              <p className="tco-dual-subtitle">
                Just like TrueCare™, TrueCom™ serves two distinct user types:
              </p>
            </div>

            <div className="tco-dual-tabs">
              {tcoDashTabs.map((tab) => (
                <button
                  key={tab.id}
                  className={`tco-dual-tab${activeTab === tab.id ? " tco-dual-tab--active" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {activeTab === tab.id && (
                    <span className="tco-dual-tab-bar" />
                  )}
                  <span className="tco-dual-tab-label">{tab.label}</span>
                </button>
              ))}
            </div>

            <p className="tco-dual-tagline">
              One view for clarity.{"\n"}One view for control.
            </p>
          </div>

          {/* ── RIGHT ── */}
          <div className="tco-dual-right">
            <img
              src={active.img}
              alt={active.title}
              className="tco-dual-right-img"
              loading="lazy"
            />
            <p className="tco-dual-right-title">{active.title}</p>
            <p className="tco-dual-right-subtitle">{active.subtitle}</p>
            <ul className="tco-dual-checklist">
              {active.checks.map((c, i) => (
                <li key={i} className="tco-dual-check-item">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="tco-dual-check-icon"
                  >
                    <path
                      d="M5 12L10 17L19 7"
                      stroke="#C04820"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  {c}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* ── MOBILE accordion layout ── */}
        <div className="tco-dual-mobile">
          <div className="tco-dual-mobile-header">
            <p className="tco-dual-tag">
              <span className="tco-dual-dot" />
              CLARITY AND CONTROL
            </p>
            <h2 className="tco-dual-title">Dual-Dashboard Architecture</h2>
            <p className="tco-dual-subtitle">
              Just like TrueCare™, TrueCom™ serves two distinct user types:
            </p>
          </div>

          {[...tcoDashTabs]
            .sort((a) => (a.id === activeTab ? -1 : 1))
            .map((tab, idx) => (
              <div
                key={tab.id}
                className={`tco-dual-acc-item${activeTab === tab.id ? " tco-dual-acc-item--active" : ""}${idx === 0 ? " tco-dual-acc-item--first" : ""}`}
              >
                <button
                  className="tco-dual-acc-trigger"
                  onClick={() => setActiveTab(tab.id)}
                >
                  {activeTab === tab.id && (
                    <span className="tco-dual-tab-bar" />
                  )}
                  <span className="tco-dual-tab-label">{tab.label}</span>
                </button>

                {activeTab === tab.id && (
                  <div className="tco-dual-acc-content">
                    <p className="tco-dual-right-subtitle">{tab.subtitle}</p>
                    <ul className="tco-dual-checklist">
                      {tab.checks.map((c, i) => (
                        <li key={i} className="tco-dual-check-item">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="tco-dual-check-icon"
                          >
                            <path
                              d="M5 12L10 17L19 7"
                              stroke="#C04820"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          {c}
                        </li>
                      ))}
                    </ul>
                    <img
                      src={tab.img}
                      alt={tab.title}
                      className="tco-dual-acc-img"
                      loading="lazy"
                    />
                  </div>
                )}
              </div>
            ))}
        </div>
      </section>
    </div>
  );
};

/* ================================================
   SECTION 7 — TRUECOM WORKFLOW
   ================================================ */
const tcoWorkflowSteps = [
  {
    num: 1,
    title: "Data Intake",
    desc: "Real-time energy generation from TrueCare™.",
  },
  {
    num: 2,
    title: "Automated Commercial Engine",
    desc: "Billing, settlements, charge mapping.",
  },
  {
    num: 3,
    title: "Compliance Engine",
    desc: "OA, DISCOM, SLDC documentation sequencing.",
  },
  {
    num: 4,
    title: "Carbon Intelligence Engine",
    desc: "REC / I-REC / Carbon Credit issuance.",
  },
  {
    num: 5,
    title: "Reporting & Dashboards",
    desc: "Monthly commercial insights + ESG statements.",
  },
  {
    num: 6,
    title: "Document Vault",
    desc: "Bank-ready, audit-ready, compliance-ready archives.",
  },
];

const TrueComWorkflow = () => {
  const sectionRef = useRef(null);
  const stepRefs = useRef([]);
  const lineRef = useRef(null);
  const leftRef = useReveal();
  const [activeStep, setActiveStep] = useState(1);

  useEffect(() => {
    const onScroll = () => {
      const section = sectionRef.current;
      const line = lineRef.current;
      if (!section || !line) return;

      const rect = section.getBoundingClientRect();
      const totalHeight = section.offsetHeight;
      const scrolled = -rect.top + window.innerHeight * 0.3;
      const progress = Math.min(Math.max(scrolled / totalHeight, 0), 1);

      const lineTrackEl = line.parentElement;
      const lineTrackHeight = lineTrackEl.offsetHeight;
      const lineFilledPx = progress * 1.4 * lineTrackHeight;

      line.style.transform = `scaleY(${Math.min(progress * 1.4, 1)})`;

      let newActive = 0;
      stepRefs.current.forEach((stepEl, i) => {
        if (!stepEl) return;
        const circleEl = stepEl.querySelector(".tco-wf-circle");
        if (!circleEl) return;
        const lineTrackTop = lineTrackEl.getBoundingClientRect().top;
        const circleCenterY =
          circleEl.getBoundingClientRect().top + circleEl.offsetHeight / 2;
        const circlePxFromLineTop = circleCenterY - lineTrackTop;
        if (lineFilledPx >= circlePxFromLineTop) newActive = i + 1;
      });

      setActiveStep(newActive);
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="tco-wf-section" ref={sectionRef}>
      <div className="tco-wf-container">
        {/* Left */}
        <div className="tco-wf-left reveal-block" ref={leftRef}>
          <p className="tco-wf-tag">
            <span className="tco-wf-dot" />
            HOW IT WORKS
          </p>
          <h2 className="tco-wf-title">TrueCom™ Workflow</h2>
          <p className="tco-wf-subtitle">
            TrueCom™ follows a fully automated commercial-first approach:
          </p>
        </div>

        {/* Right: timeline */}
        <div className="tco-wf-timeline">
          <div className="tco-wf-line-track">
            <div className="tco-wf-line-bg" />
            <div className="tco-wf-line-fill" ref={lineRef} />
          </div>

          {tcoWorkflowSteps.map((step, i) => {
            const isActive = i + 1 <= activeStep;
            return (
              <div
                className={`tco-wf-step${isActive ? " tco-wf-step--active" : ""}`}
                key={step.num}
                ref={(el) => (stepRefs.current[i] = el)}
              >
                <div className="tco-wf-circle">
                  <span className="tco-wf-num">{step.num}</span>
                </div>
                <div className="tco-wf-step-content">
                  <p className="tco-wf-step-title">{step.title}</p>
                  <p className="tco-wf-step-desc">{step.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

/* ================================================
   SECTION 8 — WHY TRUECOM MAKES US DIFFERENT
   ================================================ */
const tcoAdvCards = [
  {
    icon: tcoAdv1,
    text: (
      <>
        No EPC company in India provides{" "}
        <strong>BILLING + COMPLIANCE + CARBON</strong> under one platform
      </>
    ),
  },
  {
    icon: tcoAdv2,
    text: (
      <>
        No O&M company automates{" "}
        <strong>RECONCILIATION AND COMMERCIAL WORKFLOWS</strong>
      </>
    ),
  },
  {
    icon: tcoAdv3,
    text: (
      <>
        No solar provider offers{" "}
        <strong>DUAL DASHBOARDS FOR FINANCE TEAMS &amp; OWNERS</strong>
      </>
    ),
  },
  {
    icon: tcoAdv4,
    text: (
      <>
        No platform integrates EPC + O&M + Billing + Carbon like{" "}
        <strong>TrueTrack™ + TrueCare™ + TrueCom™</strong>
      </>
    ),
  },
];

const TrueComAdvantages = () => {
  const headerRef = useReveal();
  return (
    <section className="tco-adv">
      <div className="tco-adv-header reveal-block" ref={headerRef}>
        <p className="tco-adv-tag">
          <span className="tco-adv-dot" />
          TRUECOM ADVANTAGES
        </p>
        <h2 className="tco-adv-title">
          Why TrueCom™ Makes True Renewables Different
        </h2>
      </div>

      <div className="tco-adv-cards">
        {tcoAdvCards.map((c, i) => (
          <div className="tco-adv-card" key={i}>
            <div className="tco-adv-icon">
              <img src={c.icon} alt="" width="32" height="32" loading="lazy" />
            </div>
            <p className="tco-adv-card-text">{c.text}</p>
          </div>
        ))}
      </div>

      <p className="tco-adv-footer">
        This is why True Renewables is evolving into a full-stack solar
        intelligence ecosystem, not just an EPC
      </p>
    </section>
  );
};

/* ================================================
   SECTION 9 — THE FUTURE ROADMAP
   ================================================ */
const tcoFutureItems = [
  "Fully automated OA filing submission",
  "AI-based charge prediction models",
  "DISCOM integration APIs",
  "Automated PPA compliance tracking",
  "Multiplant consolidated reporting for large corporates",
  "AI-based carbon credit pricing alert",
  "Integrated payment gateway for collections",
  "Blockchain-based certificate verification",
];

const TrueComFuture = () => {
  const leftRef = useReveal();
  return (
    <section className="tco-future">
      <div className="tco-future-inner">
        <div className="tco-future-left reveal-block" ref={leftRef}>
          <div className="tco-future-header">
            <p className="tco-future-tag">
              <span className="tco-future-dot" />
              NEXT-GENERATION EXECUTION
            </p>
            <h2 className="tco-future-title">The Future Roadmap</h2>
          </div>

          <ul className="tco-future-list">
            {tcoFutureItems.map((item, i) => (
              <li key={i} className="tco-future-list-item">
                <svg
                  className="tco-future-check"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 12.5L9.5 18L20 7"
                    stroke="#C04820"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                {item}
              </li>
            ))}
          </ul>

          <p className="tco-future-footer tco-future-footer--desktop">
            Any company can install a solar plant.
            <br />
            But only True Renewables provides real-time, intelligent, automated
            commercial management for its lifetime.
          </p>
        </div>

        <div className="tco-future-img-wrap">
          <div className="tco-future-img-bg" />
          <img
            src={tcoSection9Img}
            alt="The Future Roadmap"
            className="tco-future-img"
            loading="lazy"
          />
        </div>

        <p className="tco-future-footer tco-future-footer--mobile">
          Any company can install a solar plant.
          <br />
          But only True Renewables provides real-time, intelligent, automated
          commercial management for its lifetime.
        </p>
      </div>
    </section>
  );
};
/* ================================================
   TRUECOM PAGE
   ================================================ */
const TrueCom = () => (
  <>
    <TrueComHero />
    <TrueComAbout />
    <TrueComWhyExists />
    <TrueComCapabilities />
    <TrueComEngine />
    <TrueComDualDashboard />
    <TrueComWorkflow />
    <TrueComAdvantages />
    <TrueComFuture />
  </>
);

export default TrueCom;
